import {SprintsRepository} from '../persistence/sprints_repository';
import {SprintApi} from '../network/sprint_api';
import {format} from 'date-fns';

export class SprintMover {
    constructor(private sprintRepository: SprintsRepository, private sprintApi: SprintApi) {}

    public async move(sprintId: number, employeeId: number, date: Date): Promise<void> {
        const sprint = this.sprintRepository.find(sprintId);
        if (sprint !== null) {
            try {
                this.sprintRepository.store({
                    ...sprint,
                    employee_id: employeeId,
                    date: format(date, 'yyyy-MM-dd') + ' 00:00:00',
                });

                const updatedSprint = await this.sprintApi.move(sprintId, employeeId, format(date, 'yyyy-MM-dd'));

                this.sprintRepository.store({
                    ...sprint,
                    ...updatedSprint,
                });
            } catch (e) {
                //On error restore
                this.sprintRepository.store(sprint);
            }
        }
    }
}
